interface Option {
  key?: string;
  label: string;
  value: string;
}

export const DEATH_OPTIONS: Array<Option> = [
  {
    key: "1",
    label: "Abortion",
    value: "abortion",
  },
  {
    key: "2",
    label: "Acidosis",
    value: "acidosis",
  },
  {
    key: "3",
    label: "Bacterial (Clostridia, E.Coli, Pasteurellosis, Salmonella, Mycoplasma)",
    value: "bacterial",
  },
  {
    key: "4",
    label: "Bladder",
    value: "bladder",
  },
  {
    key: "5",
    label: "Bloat",
    value: "bloat",
  },
  {
    key: "6",
    label: "Brain / nervous condition",
    value: "brain-nervous-condition",
  },
  {
    key: "7",
    label: "BVD",
    value: "BVD",
  },
  {
    key: "8",
    label: "Castration",
    value: "castration",
  },
  {
    key: "9",
    label: "Cardiovascular condition",
    value: "cardiovascular-condition",
  },
  {
    key: "10",
    label: "Coccidiosis",
    value: "coccidiosis",
  },
  {
    key: "11",
    label: "Displaced Abomasum",
    value: "displaced-abomasum",
  },
  {
    key: "12",
    label: "Dystocia",
    value: "dystocia",
  },
  {
    key: "13",
    label: "Fluke",
    value: "fluke",
  },
  {
    key: "14",
    label: "Fly strike",
    value: "fly-strike",
  },
  {
    key: "15",
    label: "Grass staggers / hypomagnesaemia",
    value: "hypomagnesaemia",
  },
  {
    key: "16",
    label: "IBR",
    value: "IBR",
  },
  {
    key: "17",
    label: "Johnes",
    value: "johnes",
  },
  {
    key: "18",
    label: "Ketosis",
    value: "ketosis",
  },
  {
    key: "19",
    label: "Lameness",
    value: "lameness",
  },
  {
    key: "20",
    label: "Leptospirosis",
    value: "leptospirosis",
  },
  {
    key: "21",
    label: "Limb fracture",
    value: "limb-fracture",
  },
  {
    key: "22",
    label: "Listeria",
    value: "listeria",
  },
  {
    key: "23",
    label: "Lungworm",
    value: "lungworm",
  },
  {
    key: "24",
    label: "Mastitis",
    value: "mastitis",
  },
  {
    key: "25",
    label: "Metritis",
    value: "metritis",
  },
  {
    key: "26",
    label: "Milk fever / hypocalcaemia",
    value: "hypocalcaemia",
  },
  {
    key: "27",
    label: "Mineral / vitamin imbalance",
    value: "mineral-vitamin-imbalance",
  },
  {
    key: "28",
    label: "Orf",
    value: "orf",
  },
  {
    key: "29",
    label: "Pneumonia",
    value: "pneumonia",
  },
  {
    key: "30",
    label: "Poisoning",
    value: "poisoning",
  },
  {
    key: "31",
    label: "Predation",
    value: "predation",
  },
  {
    key: "32",
    label: "Prolapse",
    value: "prolapse",
  },
  {
    key: "33",
    label: "Rotavirus",
    value: "rotavirus",
  },
  {
    key: "34",
    label: "Scour / diarrhoea",
    value: "diarrhoea",
  },
  {
    key: "35",
    label: "Septicaemia",
    value: "septicaemia",
  },
  {
    key: "36",
    label: "Spinal disease",
    value: "spinal-disease",
  },
  {
    key: "37",
    label: "TB",
    value: "tuberculosis",
  },
  {
    key: "38",
    label: "Teat / udder condition",
    value: "udder-condition",
  },
  {
    key: "39",
    label: "Twin lamb disease",
    value: "twin-lamb-disease",
  },
  {
    key: "40",
    label: "Twisted gut",
    value: "twisted-gut",
  },
  {
    key: "41",
    label: "Unknown",
    value: "unknown",
  },
  {
    key: "42",
    label: "Wire",
    value: "wire",
  },
  {
    key: "43",
    label: "Wound / injury",
    value: "injury",
  },
];
